// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cgq2m6fIqS0SHxnorjg8{border-radius:50%;place-content:center;width:24px;height:24px;display:grid}.cgq2m6fIqS0SHxnorjg8.Yyqevn5K7qYrV4vPy599{width:16px;height:16px}.cgq2m6fIqS0SHxnorjg8.xEWVPe006SwjXxKtlkcV{background:var(--background-brand-default)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `cgq2m6fIqS0SHxnorjg8`,
	"small": `Yyqevn5K7qYrV4vPy599`,
	"bg": `xEWVPe006SwjXxKtlkcV`
};
export default ___CSS_LOADER_EXPORT___;
